module.exports = __webpack_public_path__ + "static/person-to-person2-853db89eb222caf58609051670396570.jpg";